export const tradeAccountsWithPositionPeriods = [100, 101, 102, 105, 106, 107, 108, 109];

export const isTradeAccountWithPositionPeriod = (tradeAccountId: number) => {
  return tradeAccountsWithPositionPeriods.includes(+tradeAccountId);
};
